/**
 * Sales-only monthly bypass code: (two-digit year) − (month number).
 * e.g. November 2026 → 26 − 11 = "15". Regular customers typing that
 * number as a discount must not get a free checkout.
 */

export function getDynamicBypassCode(now: Date = new Date()): string {
  const twoDigitYear = now.getFullYear() % 100;
  const monthNumber = now.getMonth() + 1;
  return String(twoDigitYear - monthNumber);
}

/** True only when a sales user applies the current month's dynamic code. */
export function isSalesOnlyDynamicBypassCode(
  code: string | null | undefined,
  canSalesBypass: boolean,
  now: Date = new Date(),
): boolean {
  if (canSalesBypass !== true) return false;
  const trimmed = String(code ?? "").trim();
  return trimmed !== "" && trimmed === getDynamicBypassCode(now);
}
